import {
  buildB2BOpportunitiesUrl,
  buildJobOpportunitiesUrl,
  buildServiceOpportunitiesUrl,
} from '~/routing/urls';
import type { JobResponse } from '~/types/hlx/jobResponse';

export const ExistingInquiryNotice = ({
  response,
  side,
}: {
  response: JobResponse;
  /** Which Responses tab the B2B response is under: Buying when the viewer is the buyer of an OFFERING listing. */
  side?: 'buying' | 'selling';
}) => {
  const href =
    response.listingType === 'SERVICE'
      ? buildServiceOpportunitiesUrl(response.id)
      : response.listingType === 'MSAAS'
        ? buildB2BOpportunitiesUrl({ view: 'sent', responseId: response.id, side })
        : buildJobOpportunitiesUrl({ responseId: response.id });

  return (
    <div className="space-y-2 p-4 text-sm">
      <p role="status">
        This conversation already exists. Your new message was not sent. Copy any text you want to
        keep from this draft, then send it as a reply in the conversation.
      </p>
      <a href={href} target="_blank" rel="noopener noreferrer" className="underline">
        Open conversation in a new tab
      </a>
      <p>Your draft stays in this tab. Nothing is sent automatically.</p>
    </div>
  );
};
